<template>
  <div>
    <div class="justify-content-between align-items-center d-flex">
      <h3>
        <feather-icon size="22" icon="InfoIcon" />
        المعلومات الأساسية
      </h3>
      <b-button
        v-can="{ slug: 'ngo-profile', action: 'O' }"
        @click="openMainInfoModal"
        variant="primary"
        v-if="canUpdateCriticalInfo"
      >
        <feather-icon size="16" icon="EditIcon" class="mr-50" />
        تعديل
      </b-button>
    </div>
    <hr />
    <b-row>
      <b-col md="6" cols="12">
        <info-card
          label="معرف المنظمة"
          :value="ngoData.id"
          tooltip="هذا الحقل لايمكن تعديله لانه يتولد تلقائياً"
        />
      </b-col>
      <b-col md="6" cols="12">
        <info-card
          label="الاسم العربي"
          :value="ngoData.name_ar"
          tooltip="يتم إدخال هذا الحقل باللغة العربية حصراً"
        />
      </b-col>
      <b-col md="6" cols="12">
        <info-card
          label="الاسم الإنجليزي"
          :value="ngoData.name_en"
          tooltip="يتم إدخال هذا الحقل باللغة الإنجليزية حصراً"
        />
      </b-col>
      <b-col md="6" cols="12">
        <info-card label="الشكل القانوني" :value="ngoData.legalForm.name_ar" />
      </b-col>
      <b-col md="12" cols="12">
        <info-card label="أهداف المنظمة" :value="ngoData.objectives" />
      </b-col>
    </b-row>
    <form-modal
      v-model="mainInfoModal"
      title="المعلومات الأساسية"
      :formSchema="mainInfoSchema"
      @confirm="onMainInfoModalConfirmed"
      ref="mainInfoModal"
      :loading="loading"
    />
  </div>
</template>

<script>
import FormModal from "@/components/FormModal.vue";
import InfoCard from "@/components/InfoCard.vue";
import { BRow, BCol, BButton } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    BRow,
    BCol,
    BButton,
    InfoCard,
    FormModal,
  },

  data() {
    return {
      mainInfoModal: false,
      mainInfoSchema: {
        name_ar: {
          component: "FormInput",
          key: "name_ar",
          attrs: {
            label: "الاسم العربي",
            rules: "required",
          },
        },
        name_en: {
          component: "FormInput",
          key: "name_en",
          attrs: {
            label: "الاسم الانجليزي",
          },
        },
        objectives: {
          component: "FormTextarea",
          key: "objectives",
          attrs: {
            label: "أهداف المنظمة",
          },
        },
      },
    };
  },
  methods: {
    ...mapActions("NgoProfile/NgoInfo", ["editNgoData"]),
    openMainInfoModal() {
      this.$refs.mainInfoModal.init({
        name_ar: this.ngoData.name_ar,
        name_en: this.ngoData.name_en,
        objectives: this.ngoData.objectives,
      });
      this.mainInfoModal = true;
    },
    onMainInfoModalConfirmed(form) {
      this.editNgoData(form);
    },
  },
  computed: {
    ...mapGetters("NgoProfile/NgoInfo", ["loading"]),
    ...mapGetters("NgoProfile", ["ngoData", "canUpdateCriticalInfo"]),
  },
};
</script>
